import React from "react";
import { IBlock } from "types";

interface BlockLinkItemProps {
	block: IBlock;
	file?: boolean;
}

const BlockLinkItem: React.FC<BlockLinkItemProps> = ({ block, file }) => {
	return (
		<>
			<div style={{ fontStyle: "italic", marginBottom: 10 }}>
				{block.content}
			</div>
			<a
				href={block.content}
				target="_blank"
				rel="noreferrer"
				className="ant-btn ant-btn-primary"
			>
				{file ? "Visualizar Arquivo" : "Assistir Vídeo"}
			</a>
		</>
	);
};

export default BlockLinkItem;
